import React from 'react';
import { Box } from '@mui/material';

import { Page4Kpis } from './types';
import { wsrColors, wsrShadow } from './wsrTokens';

interface KpiRibbonProps {
  kpis: Page4Kpis;
}

interface KpiCard {
  label: string;
  value: number;
  accent: string;
  sub: string;
}

const KpiRibbon: React.FC<KpiRibbonProps> = ({ kpis }) => {
  const cards: KpiCard[] = [
    {
      label: 'Total Raised',
      value: kpis.total_raised,
      accent: wsrColors.blue,
      sub: 'Incidents + SR',
    },
    {
      label: 'Total Resolved',
      value: kpis.total_resolved,
      accent: wsrColors.green,
      sub: kpis.close_rate_pct === null ? 'No tickets in window' : `${kpis.close_rate_pct}% close rate`,
    },
    {
      label: 'Outstanding',
      value: kpis.outstanding,
      accent: wsrColors.amber,
      sub: 'Open as of week-end',
    },
    {
      label: 'Aged > 14 days',
      value: kpis.aged_over_14_days,
      accent: wsrColors.red,
      sub: 'Across all queues',
    },
  ];

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
      {cards.map((card) => (
        <Box
          key={card.label}
          sx={{
            background: '#fff',
            border: `1px solid ${wsrColors.slate200}`,
            borderRadius: '12px',
            padding: '16px 18px',
            boxShadow: wsrShadow,
          }}
        >
          <Box sx={{ fontSize: 12, color: wsrColors.slate500, fontWeight: 500 }}>{card.label}</Box>
          <Box
            sx={{
              marginTop: '6px',
              fontSize: 30,
              fontWeight: 700,
              color: card.accent,
              letterSpacing: '-0.02em',
            }}
          >
            {card.value}
          </Box>
          <Box sx={{ marginTop: '4px', fontSize: 12, color: wsrColors.slate400 }}>{card.sub}</Box>
        </Box>
      ))}
    </Box>
  );
};

export default KpiRibbon;
